import React, { useState } from 'react'
// import agreegatorlisting from '../agreegatorlisting'
import '../../../BuisnessDashboard/Dashboard.scss'
import DashboardMain from './DashboardMain';
import AggregatorListing from './AggregatorLsiting'

import ConfigPage from "../components/ConfigMainTabs";
import AggregatorDetails from "../aggregatorDetails";

export default function Main({ setViewState, admin, pageViewHandler }) {
    const [currentSection, setcurrentSection] = useState("Dashboard");
    const [detailShow, setDetailsShow] = useState('list');
    const [editdata, setsetEditdata] = useState('');
    const [listData, setListData] = useState('');
    const [aggregatorId, setAggregatorId] = useState("");

    const handleSection = (type) => {
        setcurrentSection(type)
    }

    const EyeHandler = (partnerId, listData) => {
        setListData(listData)
        setAggregatorId(partnerId);
    }
    const EditHandler = (item) => {
        setsetEditdata(listData)
    }

    return (
        <>
            {
                detailShow == "list" ?
                    <div className="Main-dashboard">
                        <div className="dashboard-main-content" style={{ margin: "0", scrollbarWidth: "none",overflow:'auto' }}>
                            <div className='OverView-Main-Section'>
                                <div className='HeadingFilter-Section' style={{ marginTop: '30px' }}>
                                    <div>
                                        <h4>{currentSection == "Dashboard" ? "Dashboard" : currentSection == "Aggregator" ? "Aggregator List" : ""}</h4>
                                    </div>
                                    <div className='customBtnops'>
                                        <button className={`customBtns ${currentSection == "Dashboard" ? "active" : ""}`} onClick={() => handleSection("Dashboard")}>Dashboard</button>
                                        <button className={`customBtns ${currentSection == "Aggregator" ? "active" : ""}`} onClick={() => handleSection("Aggregator")}>Aggregator</button>

                                    </div>
                                </div>



                                {
                                    currentSection == "Dashboard" ?
                                        <DashboardMain
                                            admin={admin}
                                        />
                                        : ""
                                }
                                {
                                    currentSection == "Aggregator" ?
                                        <AggregatorListing
                                            admin={admin}
                                            setDetailsShow={setDetailsShow}
                                            detailShow={detailShow}
                                            EyeHandler={EyeHandler}
                                            EditHandler={EditHandler}
                                        />
                                        : ""
                                }
                            </div>
                        </div>
                    </div>
                    : ""}

            {detailShow === 'view' ?
                <AggregatorDetails
                    listData={listData}
                    aggregatorId={aggregatorId}
                    admin={admin}
                    setDetailShow={setDetailsShow}
                />
                : ""}
            {detailShow === 'edit' ?
                <ConfigPage setDetailShow={setDetailsShow} editdata={editdata} />
                : ""}
        </>
    )
}
